import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import FilterComponent from "../FilterComponent";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import { Delete } from "@mui/icons-material";
import * as utils from "../../Utils/comman";
import { useSelector } from "react-redux";
import ReasonModal from "../ReasonModal";
import {
  AddCircle,
  ArrowDown,
  DocumentDownload,
  Edit,
  Edit2,
  Eye,
  Mobile,
  ProfileAdd,
  ShieldTick,
  ShoppingCart,
  Trash,
} from "iconsax-react";
import moment from "moment/moment";
import { Link } from "react-router-dom";
import * as XLSX from "xlsx";
import CustomPagination from "../../Utils/CustomPagination";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function List(props) {
  const [invertList, setinvertList] = useState([]);
  const [page, setPage] = useState(1);
  const countPerPage = 10;
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions,
  );
  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalText, setModalText] = useState("");
  const handleShowModal = useCallback(
    (title, text) => () => {
      setModalTitle(title);
      setModalText(text);
      setShowModal(true);
    },
    [],
  );
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [reset, setreset] = useState(false);

  const handleAddClick = (e) => {
    const propdata = {
      mode: "add",
    };
    props.onChange(propdata);
  };

  const columns = [
    {
      name: (
        <div>
          Invert Date <br />
        </div>
      ),
      selector: (row) => moment(row.createdAt).format("DD-MM-YYYY"),
    },
    {
      name: "Po No",
      selector: (row, index) =>
        utils.hasPermission(
          primaryMenuRes,
          "Invert",
          "invert.list_for_installation",
        )
          ? row?.po_order_id
          : row.order_id,
      width:'200px'
    },
    {
      name: "Invoice No",
      selector: (row, index) => row.invoice_no,
    },
    {
      name: "Invert No",
      selector: (row, index) => row.invert_no,
    },
    {
      name: "CER No",
      selector: (row, index) => row.cer_no,
      omit: !utils.hasPermission(
        primaryMenuRes,
        "Invert",
        "invert.list_for_installation",
      ),
    },
    {
      name: "Store Remark",
      selector: (row, index) => row.store_remark,
      selector: (row) => row.store_remark,
      cell: (row) => {
        const wordCount = row.store_remark?.split(" ").length;
        return wordCount > 2 ? (
          <RB.Button
            className="btn btn-flat"
            onClick={handleShowModal("Store Remark", row.store_remark)}
          >
            <Eye />
          </RB.Button>
        ) : (
          <span>{row.store_remark}</span>
        );
      },
      omit: utils.hasPermission(
        primaryMenuRes,
        "Invert",
        "invert.list_for_installation",
      ),
    },
    {
      name: "QC Remark",
      selector: (row, index) => row.qc_remark,
      selector: (row) => row.qc_remark,
      cell: (row) => {
        const wordCount = row.qc_remark?.split(" ").length;
        return wordCount > 2 ? (
          <RB.Button
            className="btn btn-flat"
            onClick={handleShowModal("Qc Remark", row.qc_remark)}
          >
            <Eye />
          </RB.Button>
        ) : (
          <span>{row.qc_remark}</span>
        );
      },
      omit: utils.hasPermission(
        primaryMenuRes,
        "Invert",
        "invert.list_for_installation",
      ),
    },

    {
      name: "Action",
      center: true,
      cell: (row) => (
        <>
          {/* <RB.Button
            className="btn-flat ms-1"
            title="View"
            onClick={handleView(row)}
          >
            <Eye />
          </RB.Button> */}
          {utils.hasPermission(
            primaryMenuRes,
            "Invert",
            "invert.list_for_installation",
          ) && (
            <>
              {(!row?.installation_id || row.installation_id === "0") && (
                <RB.Button
                  className="btn-flat ms-1"
                  title="Installation Certification"
                  onClick={handleInstallation(row)}
                >
                  <ShieldTick />
                </RB.Button>
              )}
            </>
          )}
          {utils.hasPermission(primaryMenuRes, "Invert", "invert.edit") && (
            <>
              {row.qcBy == "0" && (
                <RB.Button
                  className="btn-flat ms-1"
                  title="Edit"
                  onClick={handelEdit(row)}
                >
                  <Edit2 />
                </RB.Button>
              )}
            </>
          )}
          {utils.hasPermission(primaryMenuRes, "Invert", "invert.delete") && (
            <>
              {row.qcBy == "0" && (
                <RB.Button
                  className="btn-flat ms-1"
                  title="Delete"
                  onClick={showDelete(row)}
                >
                  <Trash />
                </RB.Button>
              )}
            </>
          )}
        </>
      ),
    },
  ];

  const handleView = useCallback((row) => async () => {
    const propdata = {
      mode: "view",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handleInstallation = useCallback((row) => async () => {
    const propdata = {
      mode: "installation",
      rowData: {},
    };
    props?.setInvertId(row?.id);
    props.onChange(propdata);
  });

  useEffect(() => {
    if (
      utils.hasPermission(
        primaryMenuRes,
        "Invert",
        "invert.list_for_installation",
      )
    ) {
      getPoManagerList();
    } else {
      getInvert();
    }
  }, [page, primaryMenuRes]);

  const getPoManagerList = () => {
    utils
      .callAPI(
        "get",
        `/purchaseorder/invert-capital?page=${page}&per_page=${countPerPage}`,
      )
      .then((res) => {
        if (typeof res !== "undefined") {
          setinvertList(res);
          // setFilter(false)
        } else {
          setinvertList([]);
        }
      })
      .catch((err) => {
        setinvertList([]);
      });
  };

  const getInvert = () => {
    const fromDate = startDate ? moment(startDate).format("YYYY-MM-DD") : "";
    const toDate = endDate ? moment(endDate).format("YYYY-MM-DD") : "";

    utils
      .callAPI(
        "get",
        `/purchaseorder/invert-list?page=${page}&per_page=${countPerPage}&from_date=${fromDate}&to_date=${toDate}`,
      )
      .then((res) => {
        if (typeof res !== "undefined") {
          setinvertList(res);
          setreset(false);
          // setFilter(false)
        } else {
          setinvertList([]);
          setreset(false);
        }
      })
      .catch((err) => {
        setinvertList([]);
        setreset(false);
      });
  };

  const handelEdit = useCallback((row) => async () => {
    const propdata = {
      mode: "edit",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const showDelete = useCallback((row) => async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        utils
          .callAPI("get", `/purchaseorder/invert-delete?id=${row?.id}`, "")
          .then((res) => {
            if (typeof res !== "undefined") {
              getInvert();
            }
          })
          .catch((err) => {});
      }
    });
  });

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleDownload = () => {
    const fromDate = startDate ? moment(startDate).format("YYYY-MM-DD") : "";
    const toDate = endDate ? moment(endDate).format("YYYY-MM-DD") : "";

    const isInstallation = utils.hasPermission(
      primaryMenuRes,
      "Invert",
      "invert.list_for_installation",
    );

    utils
      .callAPI(
        "get",
        `/purchaseorder/invert-list?page=0&per_page=0&from_date=${fromDate}&to_date=${toDate}`,
      )
      .then((res) => {
        const rows = Array.isArray(res?.result) ? res.result : [];

        // if (!rows.length) {
        //   return Swal.fire({
        //     icon: "info",
        //     title: "No Data Found",
        //     text: "No invert records available for the selected range.",
        //     confirmButtonColor: "#0d6efd",
        //   });
        // }

        const csvHeader = [
          "Invert Date",
          "PO No",
          "Invoice No",
          "Invert No",
          "CER No",
          "Store Remark",
          "QC Remark",
        ].join(",");

        const esc = (v) => `${v ?? ""}`.replace(/"/g, '""');

        const csvRows = rows.map((r) => {
          return [
            `"${esc(moment(r.createdAt).format("DD-MM-YYYY"))}"`,
            `"${esc(isInstallation ? r.po_order_id : r.order_id)}"`,
            `"${esc(r.invoice_no)}"`,
            `"${esc(r.invert_no)}"`,
            `"${esc(r.cer_no)}"`,
            `"${esc(r.store_remark)}"`,
            `"${esc(r.qc_remark)}"`,
          ].join(",");
        });

        const csvContent = [csvHeader, ...csvRows].join("\n");
        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });

        const link = document.createElement("a");
        const fileName = `Invert_List_${fromDate || "all"}_to_${toDate || "all"}.csv`;

        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((err) => {
        console.error("Download Error:", err);
      });
  };

  const handleFilter = () => {
    setPage(1);
    if (
      utils.hasPermission(
        primaryMenuRes,
        "Invert",
        "invert.list_for_installation",
      )
    ) {
      getPoManagerList();
    } else {
      getInvert();
    }
  };

  const handleReset = () => {
    setDateRange([null, null]);
    setPage(1);
    setreset(true);
  };

  useEffect(() => {
    if (reset) {
      getInvert();
    }
  }, [reset]);

  return (
    <>
      <div className="section-body">
        <RB.Card className="card shadow ">
          <div className="floating-btns-holder-artisan">
            {utils.hasPermission(primaryMenuRes, "Invert", "invert.create") && (
              <a
                href
                className="btn btn-dark btn-circle"
                variant="dark"
                onClick={handleAddClick}
              >
                <AddCircle />
              </a>
            )}
            <a
              href
              className={`${
                invertList?.result?.length == 0 ? "disabled" : ""
              } btn btn-primary btn-circle ms-2`}
              variant="primary"
              onClick={() => handleDownload()}
            >
              <DocumentDownload />
            </a>
          </div>

          <RB.Card.Body>
            <div
              className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-2
            "
            >
              <h4 className="mb-0"></h4>

              <div className="d-flex gap-2 align-items-center flex-wrap">
                <DatePicker
                  selectsRange
                  startDate={startDate}
                  endDate={endDate}
                  onChange={(update) => setDateRange(update)}
                  isClearable
                  placeholderText="Select date range"
                  className="form-control"
                  dateFormat="dd-MM-yyyy"
                />

                <RB.Button variant="primary" onClick={handleFilter}>
                  Filter
                </RB.Button>

                <RB.Button variant="secondary" onClick={handleReset}>
                  Reset
                </RB.Button>
              </div>
            </div>
            {utils.hasPermission(primaryMenuRes, "Invert", "invert.view") && (
              <>
                <DataTable
                  columns={columns}
                  data={invertList.result}
                  highlightOnHover
                  responsive
                  pagination
                  paginationServer
                  paginationTotalRows={invertList.total}
                  paginationPerPage={countPerPage}
                  paginationComponentOptions={{
                    noRowsPerPage: true,
                  }}
                  paginationComponent={() => (
                    <CustomPagination
                      currentPage={page}
                      totalRows={invertList.total}
                      rowsPerPage={countPerPage}
                      onPageChange={handlePageChange}
                    />
                  )}
                  striped
                  onChangePage={(page) => setPage(page)}
                  persistTableHead
                  customStyles={{
                    head: {
                      style: {
                        fontSize: "0.875rem", // Adjust the font size as needed
                        fontWeight: "bold", // Adjust the font weight as needed
                      },
                    },
                  }}
                  // subHeader
                  // subHeaderComponent={subHeaderComponent}
                />
              </>
            )}
          </RB.Card.Body>
        </RB.Card>
      </div>
      <ReasonModal
        show={showModal}
        onHide={() => setShowModal(false)}
        title={modalTitle}
        text={modalText}
      />
    </>
  );
}

export default List;
